import React, { useState } from 'react';
import styles from './rateticket.module.css';
import ReactGA from 'react-ga';
import { fetchFeedbackTicket, selectTicketRate } from '../../store/ticketSlice';
import { useDispatch, useSelector } from 'react-redux';

const Star = ({ value, rate, handleSelect }) => {
	return (
		<i
			className={`ibon-star ${styles.icon} ${rate > 0 && rate >= value ? styles.rateSelected : ''}`}
			onClick={() => handleSelect(value)}
		/>
	);
};

const RateTicket = ({ ticket_uuid }) => {
	const [rateTicket, setRateTicket] = useState(0);
	const [includeDetail, setIncludeDetail] = useState(false);
	const [submittedForm, setSubmittedForm] = useState(false);
	const [selectedValues, setSelectedValues] = useState([]);
	const [commentText, setCommentText] = useState('Déjanos tus comentarios para mejorar');
	const [titleTextFeedback, setTitleTextFeedback] = useState('¿Qué estuvo mal?');
	const [commentValue, setCommentValue] = useState('');
	const dispatch = useDispatch();
	const ticketRate = useSelector(selectTicketRate);

	const handleSelectTicket = (value: number): void => {
		
		setIncludeDetail(true);
		setRateTicket(value);
		if(value === 1 || value === 2 || value === 3){
			setCommentText('Déjanos tus comentarios para mejorar')
			setTitleTextFeedback('¿Qué estuvo mal?')
		}

		if(value === 4){
			setCommentText('Cuéntanos qué podemos mejorar')
			setTitleTextFeedback('¿Qué podemos mejorar?')
		}

		if(value === 5){
			setCommentText('Cuéntanos qué hicimos bien')
			setTitleTextFeedback('¿Qué te gustó?')
		}

	};

	const handleInputChange = event => {
		const target = event.target;
		const isChecked = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		if (isChecked) {
			setSelectedValues([...selectedValues, { isChecked, name, value: target.value }]);
		} else {
			setSelectedValues(selectedValues.filter(item => item.name !== name));
		}
	};
	const onSubmit = async e => {
		e.preventDefault();
		const feedback = selectedValues.map(item => item.value).join(', ');

		ReactGA.event({
			category: 'feedback-ticket',
			action: `stars: ${rateTicket}`,
			label: `${feedback}`
		});

		await dispatch(
			fetchFeedbackTicket({
				ticket_rate: rateTicket,
				feedback: feedback,
				comment: commentValue,
				ticket_uuid: ticket_uuid
			})
		);
		setSubmittedForm(true);
	};

	const reasonsCatalog = {
		0: [],
		1: [
			{ value: 'Funcionamiento de la App', name: 'detail1' },
			{ value: 'Mi asesor no fue claro', name: 'detail2' },
			{ value: 'Velocidad de respuesta', name: 'detail3' },
			{ value: 'No resolvieron mi problema', name: 'detail4' },
			{ value: 'El seguimiento a mi caso', name: 'detail5' }
		],
		2: [
			{ value: 'Funcionamiento de la App', name: 'detail1' },
			{ value: 'Mi asesor no fue claro', name: 'detail2' },
			{ value: 'Velocidad de respuesta', name: 'detail3' },
			{ value: 'No resolvieron mi problema', name: 'detail4' },
			{ value: 'El seguimiento a mi caso', name: 'detail5' }
		],
		3: [
			{ value: 'Funcionamiento de la App', name: 'detail1' },
			{ value: 'Mi asesor no fue claro', name: 'detail2' },
			{ value: 'Velocidad de respuesta', name: 'detail3' },
			{ value: 'No resolvieron mi problema', name: 'detail4' },
			{ value: 'El seguimiento a mi caso', name: 'detail5' }
		],
		4: [
			{ value: 'Funcionamiento de la App', name: 'detail1' },
			{ value: 'Velocidad de atención', name: 'detail2' },
			{ value: 'Atención del asesor', name: 'detail3' },
			{ value: 'Solución de mi problema', name: 'detail4' }
		],
		5: [
			{ value: 'Funcionamiento de la App', name: 'detail1' },
			{ value: 'Velocidad de atención', name: 'detail2' },
			{ value: 'Atención del asesor', name: 'detail3' },
			{ value: 'Solución de mi problema', name: 'detail4' }
		]
	}

	const reasons = reasonsCatalog[rateTicket]

	return (
		<div className={styles.container}>
			{!submittedForm && (
				<>
					<p className="text-center">
						<b>Queremos ofrecerte un servicio cada vez mejor. ¿Qué te pareció nuestra atención?</b>
					</p>
					<form onSubmit={onSubmit}>
						<div className="text-center m-y-16">
							{[1, 2, 3, 4, 5].map(value => (
								<Star key={value} value={value} rate={rateTicket} handleSelect={handleSelectTicket} />
							))}
						</div>
						{includeDetail && (
							<>
								<p className="text-center">
									<b>{titleTextFeedback}</b>
								</p>
								<ul className="text-center">
									{reasons.map(reason => {
										return (
											<li className={styles.checkbox} key={reason.name}>
												<input
													onChange={handleInputChange}
													hidden
													type="checkbox"
													name={reason.name}
													id={reason.name}
													value={reason.value}
												/>
												<label htmlFor={reason.name}>{reason.value}</label>
												<br />
											</li>
										);
									})}
								</ul>
								<br />
								<div className='text-left p-l-16'>
									<label htmlFor="comment" className='bold'>{commentText}</label>
									<input
										id="comment"
										type="text"
										name="comment"
										onChange={(value) => setCommentValue(value.target.value)}
										value={commentValue}
									/>
									<hr />
								</div>
							</>
						)}
						

						{rateTicket > 0 && (
							<div className={`m-16 ${styles.button}`}>
								<button disabled={ticketRate.status === 'pending'} className="btn-primary">
									Enviar
								</button>
							</div>
						)}
					</form>
				</>
			)}
			{submittedForm && <p>Gracias por tus sugerencias</p>}
		</div>
	);
};

export default RateTicket;
